import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

const Input = styled.input`
  font-family: 'OpenSans';
  background-color: transparent;
  border: none;
  width: calc(100% - ${({ icon }) => (icon ? 50 : 5)}px);

  :focus {
    outline: none;
  }

  font-size: ${pxToRem('16px')};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.black.one};
  border: none;
  transition: border 0.5s;

    ::placeholder {
    font-weight: normal;
    font-style: italic;
    color: ${props => props.theme.colors.grayText};
  }

  ::-webkit-input-placeholder {
    /* Edge */
    font-weight: normal;
    font-style: italic;
    color: ${props => props.theme.colors.grayText};
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    font-weight: normal;
    font-style: italic;
    color: ${props => props.theme.colors.grayText};
  }

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `}

  ${({ readonly }) =>
    readonly &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}

  ${props =>
    props.isEditable &&
    !props.isLeadDetail &&
    css`
      border-bottom: ${pxToRem('1px')} solid ${props.theme.colors.black.one};
    `}
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: ${pxToRem('6px')};
  ${props =>
    props.status === 'invalid' &&
    css`
      border-color: ${props.theme.colors.semantic.secondary};
    `}
  padding: ${props => (props.padding ? `${props.padding}` : 'unset')};
  display: flex;

  ${({ disabled, readonly }) =>
    disabled &&
    !readonly &&
    css`
      cursor: not-allowed;
    `};

  ${({ readonly, theme }) =>
    readonly &&
    css`
      pointer-events: none;
      border: none;
      background-color: ${theme.colors.transparent};
    `};
`;

const SpanIcon = styled.span`
  position: absolute;
  width: ${pxToRem('50px')};
  height: ${pxToRem('47px')};
  right: ${pxToRem('5px')};
  top: -${pxToRem('1px')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 ${pxToRem('6px')} ${pxToRem('6px')} 0;
  color: ${props => props.theme.colors.black.one};
  cursor: pointer;
  font-size: ${pxToRem('25px')};
`;

const ValidInput = styled.span`
  position: absolute;
  font-size: ${pxToRem('35px')};
  font-weight: 700;
  top: 50%;
  right: ${pxToRem('5px')};
  color: ${({ theme }) => theme.colors.semantic.tertiary};
  transform: translate(0, -50%);
`;

export { Input, InputContainer, SpanIcon, ValidInput };
